import React, { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileTabBar from "./MobileTabBar";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {/* Spacer so fixed bottom nav never hides footer/content on phones */}
      <div className="md:hidden" style={{ height: "calc(58px + env(safe-area-inset-bottom))" }} aria-hidden />
      <MobileTabBar />
    </div>
  );
}
